import { listViewStore } from 'owa-mail-list-store';
import pinConversations from './pinConversations';
import pinItems from './pinItems';
/**
 * Toggle the isPinned value of the rows
 * @param rowKeys to be pinned/unpinned
 * @param tableViewId the table view id
 * @param isPinnedToSet the isPinned value to be set
 * @param actionSource the action source
 */
export default function markRowsPinnedUnpinned(rowKeys, tableViewId, isPinnedToSet, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            pinConversations(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
        case 1 /* Message */:
            pinItems(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
    }
}
//# sourceMappingURL=markRowsPinnedUnpinned.js.map